import { createLocaleService } from './LocaleService.impl';
import { pageDefaultLanguage } from './pageDefaultLanguage';

export const myLocaleService = createLocaleService();

/** Public pages: no app session, the language they open in is their workspace's. */
export const myPublicPageLocaleService = createLocaleService({
  resolveAppLanguage: pageDefaultLanguage.resolve
});
